// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.border {
    box-sizing: border-box;
    position: absolute;
    z-index: var(--zIndex);
}

.border--top {
    left: 0;
    top: 0;
    width: 100%;
    border-width: var(--borderThickness) 0 0 0;
    border-style: var(--borderStyle);
    border-color: var(--borderColor);
}

.border--bottom {
    left: 0;
    bottom: 0;
    width: 100%;
    border-width: 0 0 var(--borderThickness) 0;
    border-style: var(--borderStyle);
    border-color: var(--borderColor);
}

.border--left {
    top: 0;
    left: 0;
    height: 100%;
    border-width: 0 0 0 var(--borderThickness);
    border-style: var(--borderStyle);
    border-color: var(--borderColor);
}

.border--right {
    top: 0;
    right: 0;
    height: 100%;
    border-width: 0 var(--borderThickness) 0 0;
    border-style: var(--borderStyle);
    border-color: var(--borderColor);
}

.content {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/styles/border.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,MAAM;IACN,WAAW;IACX,0CAA0C;IAC1C,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,SAAS;IACT,WAAW;IACX,0CAA0C;IAC1C,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,MAAM;IACN,OAAO;IACP,YAAY;IACZ,0CAA0C;IAC1C,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,0CAA0C;IAC1C,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".border {\r\n    box-sizing: border-box;\r\n    position: absolute;\r\n    z-index: var(--zIndex);\r\n}\r\n\r\n.border--top {\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    border-width: var(--borderThickness) 0 0 0;\r\n    border-style: var(--borderStyle);\r\n    border-color: var(--borderColor);\r\n}\r\n\r\n.border--bottom {\r\n    left: 0;\r\n    bottom: 0;\r\n    width: 100%;\r\n    border-width: 0 0 var(--borderThickness) 0;\r\n    border-style: var(--borderStyle);\r\n    border-color: var(--borderColor);\r\n}\r\n\r\n.border--left {\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    border-width: 0 0 0 var(--borderThickness);\r\n    border-style: var(--borderStyle);\r\n    border-color: var(--borderColor);\r\n}\r\n\r\n.border--right {\r\n    top: 0;\r\n    right: 0;\r\n    height: 100%;\r\n    border-width: 0 var(--borderThickness) 0 0;\r\n    border-style: var(--borderStyle);\r\n    border-color: var(--borderColor);\r\n}\r\n\r\n.content {\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: auto;\r\n    position: relative;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
